module.exports = __webpack_public_path__ + "img/07.7cf587fe.png";